export const TESTING_COVER_IMAGE_URL = 'placeholder-for-test.jpeg'
